module.exports = __webpack_public_path__ + "img/4Z1_212.f9e5744d.png";